<div class="login-form flex flex-col lg:flex-row min-h-screen">
  <div class="lg:w-7/12 w-full flex flex-col items-center justify-center bg-gray-100 p-6 leftSide">
    <div class="left-logo-screen">
      <div class="mb-4">
        <img src="assets/logo2.png" class="h-16" alt="Logo" />
      </div>
      <div class="mb-4">
        <img src="assets/tina2.png" class=" h-52 md:h-96" alt="Tina" />
      </div>
      <div class="text-center">
        <h2 class="text-2xl font-bold heading">Welcome To Gravitas AI</h2>
        <p class="text-lg italic text-gray-600 subheading">" Designing Tomorrow With Conversational AI "</p>
      </div>
    </div>
  </div>
  <div class="lg:w-5/12 w-full flex flex-col items-center justify-center p-6 rightSide">
    <form class="middleContainer" *ngIf="!this.otpForm" [formGroup]="form" novalidate>
      <div class="inputdiv">
        <div class="login-text" *ngIf="!this.otpForm">Log in</div>
        <div>
          <div for="over_label" style="margin-bottom: 10px;" class="text-[#000] lg:text-[#fff]">User Name</div>
          <p-iconfield>
            <input pInputText id="on_label" formControlName="username" name="username" fullWidth pSize="large"
              class="input-text w-full"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formError['username'].errors && formError['username'].errors['required']}"
              autocomplete="on" />
            <p-inputicon class="pi pi-user" style="margin-right: 10px;" />

          </p-iconfield>
          <small id="username-help" class="mtErr"
            *ngIf="submitted && formError['username'].errors &&formError['username'].errors['required']">
            username is required</small>
        </div>
      </div>


      <div class="inputdiv" style="margin-top: 15px">

        <div>
          <div for="over_label" style="margin-bottom: 10px;" class="text-[#000] lg:text-[#fff]">Password</div>
          <p-iconfield>
            <input pInputText id="on_label" formControlName="password" name="password"
              [type]="isPasswordVisible ? 'text' : 'password'" fullWidth pSize="large"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formError['password'].errors && formError['password'].errors['required']}"
              class="input-text w-full" autocomplete="on" />


            <p-inputicon class="pi cursor-pointer" [ngClass]="{'pi-eye' : isPasswordVisible,
                'pi-eye-slash' : !isPasswordVisible
                }" (click)="isPasswordVisible = !isPasswordVisible" style="margin-right: 10px;" />

          </p-iconfield>

          <small id="username-help" class="mtErr"
            *ngIf="submitted && formError['password'].errors &&formError['password'].errors['required']">
            Password is required</small>
        </div>

      </div>

      <!-- p-select for dev and prod -->
      <div class="inputdiv" style="margin-top: 15px">
        <div>
          <div for="over_label" style="margin-bottom: 10px;" class="text-[#000] lg:text-[#fff]">Environment</div>
          <p-select [options]="envList" class="location-select" name="environment" formControlName="environment"
            optionLabel="name" optionValue="value" placeholder="Select an Environment" />

          <small id="username-help" class="mtErr"
            *ngIf="submitted && formError['environment'].errors &&formError['environment'].errors['required']">
            Environment is required</small>
            
        </div>
      </div>

      <div>{{selectedEnv}}</div>
      <div class="w-full">
        <button class="w-full login-button" [disabled]="isLoading" type="button" (click)="onSubmit()">
          <i class="pi" [ngClass]="{
                  'pi-spin pi-spinner': isLoading,
                  'pi-sign-in': !isLoading
                }" style="margin-right: 7px;"></i>
          {{ buttonTitle }}
        </button>
        <!-- <button class="login-button" style="margin-top: 25px;">Login</button> -->
      </div>

      <div class="forgetpass" (click)="forgetPassword()">
        Forgot Password ?
      </div>
    </form>

    <div *ngIf="this.otpForm" class="otpbox">
      <h3 class="fw-normal mb-3 pb-3 login-text">Verify OTP</h3>

      <div style="margin-bottom: 31px;
    margin-top: -23px;">
        <div for="over_label" style="color: #fff; margin-bottom: 10px;">Enter OTP</div>
        <p-inputotp [(ngModel)]="userOTP" [mask]="true" size="large" />
      </div>

      <div class="pt-1 mb-4 _center mt-4 w-full">
        <button style="margin-top: -5px;" class="btn btn-default btn-md login-button w-full" [disabled]="isLoading"
          type="button" (click)="onOTPLogin()">
          <i class="pi" [ngClass]="{
                  'pi-spin pi-spinner': isLoading,
                  'pi-sign-in': !isLoading
                }" style="margin-right: 7px;"></i>
          {{ buttonTitle }}
        </button>
      </div>
    </div>
  </div>
</div>
<p-toast></p-toast>